import { ContactPersonManager } from '@ayocore/erp/crm/client/components/ContactPersonManager';
import type { ContactPerson } from '../../../../../schemas/contact-person.schema';
import type { ContactChannel } from '../../../../../schemas/contact-channel.schema';

interface PartnerContactPersonsProps {
  entityId: number;
  entityType: 'crm::PartnerRepository' | 'crm::LeadRepository';
  contactPersons: (ContactPerson & { is_primary?: boolean; is_active?: boolean; role?: string })[];
  onContactPersonsChanged: () => void;
  /** Показать всех контактных лиц, а не только основных */
  showAll?: boolean;
  /** Показать поле поиска */
  showSearch?: boolean;
  /** Можно ли заводить новые контактные лица. По умолчанию — да. */
  canAdd?: boolean;
  /** Можно ли править карточку конкретного контактного лица. По умолчанию — да. */
  canEditContact?: (contact: ContactPerson) => boolean;
  /** Можно ли править конкретный канал связи контактного лица. По умолчанию — да. */
  canEditChannel?: (channel: ContactChannel) => boolean;
}

export function PartnerContactPersons({
  entityId,
  entityType,
  contactPersons,
  onContactPersonsChanged,
  showAll,
  showSearch,
  canAdd,
  canEditContact,
  canEditChannel,
}: PartnerContactPersonsProps) {
  return (
    <ContactPersonManager
      entityId={entityId}
      entityType={entityType}
      contactPersons={contactPersons}
      onContactPersonsChanged={onContactPersonsChanged}
      showAll={showAll}
      showSearch={showSearch}
      canAdd={canAdd}
      canEditContact={canEditContact}
      canEditChannel={canEditChannel}
    />
  );
}
